export const decisionReceiptExportSchema = "strategy-decision-export-0.1.0";

export function buildDecisionExportPacket({ receipt, domain, selectedOption }) {
  return {
    schemaVersion: decisionReceiptExportSchema,
    exportedAt: new Date().toISOString(),
    app: "Strategy",
    domain: {
      id: domain.id,
      label: domain.label,
      objective: domain.objective
    },
    selectedOptionId: selectedOption?.id ?? null,
    receipt,
    claimBoundary:
      "Exported decision packets are operator-model records for audit and review. They are not legal, financial, medical, or production advice."
  };
}

export function receiptToCsv(receipt) {
  const columns = [
    "rank",
    "optionId",
    "label",
    "score",
    "scorePercent",
    "gatePassed",
    "failedGates",
    "evidenceCount",
    "missingEvidenceCount",
    "nextAction"
  ];

  const rows = (receipt.ranked ?? []).map((option, index) => [
    index + 1,
    option.id,
    option.label,
    option.score,
    option.scorePercent,
    option.gate.value === 1 ? "true" : "false",
    option.gate.failed.map((gate) => gate.label).join("; "),
    option.evidence.length,
    option.missingEvidence.length,
    option.nextAction
  ]);

  return [columns, ...rows].map((row) => row.map(csvCell).join(",")).join("\n");
}

function csvCell(value) {
  const text = String(value ?? "");
  if (!/[",\n]/.test(text)) return text;
  return `"${text.replaceAll('"', '""')}"`;
}

export function downloadTextFile({ filename, mimeType, content }) {
  if (typeof document === "undefined" || typeof URL === "undefined" || typeof Blob === "undefined") {
    return false;
  }

  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.style.display = "none";
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
  return true;
}
